/**
 * §P.7 · El marco de «El club»: las pestañas y el guardián.
 *
 * Cuatro pantallas bajo una sección por lo mismo que «Cobros»: es un solo trabajo
 * con cuatro caras —lo que se configura el primer día y se toca dos veces al año—.
 * El porqué de agruparlas, y el orden, están en `club/secciones.ts`.
 *
 * El guardián está aquí y no en cada pantalla, igual que en `MarcoDeCobros`: con
 * rutas de verdad, `/club/personal` se puede escribir en la barra, y la
 * comprobación tiene que vivir en un sitio y no en cuatro.
 */
import { Link, Navigate, Outlet, useRouterState } from '@tanstack/react-router';
import { vistasDelClubPara } from '@/club/secciones';
import { useContextoDelClub } from '@/club/contexto';
import { puedeVerElClub } from '@/club/permisos';

export function MarcoDelClub() {
  const camino = useRouterState({ select: (s) => s.location.pathname });
  const { rol } = useContextoDelClub();

  // `replace` para que «atrás» no devuelva aquí y deje al entrenador rebotando.
  if (!puedeVerElClub(rol)) return <Navigate to="/alumnos" replace />;

  return (
    <>
      <nav className="pestañas" aria-label="Pantallas del club">
        {vistasDelClubPara(rol).map((v) => {
          const destino = `/club/${v.id}`;
          return (
            <Link
              key={v.id}
              to={destino}
              className={
                camino.startsWith(destino) ? 'pestaña-activa' : 'btn-plano'
              }
            >
              {v.etiqueta}
            </Link>
          );
        })}
      </nav>

      <Outlet />
    </>
  );
}
